import moment from "moment";
import {getPluginConfig} from "../start-ui";

export default function(value, output = null, input = null) {
    let config = getPluginConfig('moment');
    if (output === null) {
        output = config.defaultOutputFormat;
    }
    if (input === null) {
        input = config.defaultInputFormat;
    }
    let date = value === 'now' ? moment() : moment(value, input);
    return date.format(output);
}